// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__30ocL","list":"styles_list__kRkSK"};